// TODO: remove eslint disable
/* eslint-disable */
import React, { useState } from "react";
import { Label, Fade } from "reactstrap";
import ReactSelect from "react-select";
import PropTypes from "prop-types";

import { styles as defaultStyles } from "../../helpers/select/styles/index";
import {
  DropdownIndicator,
  EmptyIndicatorSeparator as IndicatorSeparator
} from "../../helpers/select/components";

export default function Select(props) {
  const {
    value,
    label = "",
    containerClass = "",
    labelClass = "",
    optionLabel,
    optionValue,
    options,
    handleChange,
    styles,
    selectForThePushForm,
    ...selectOptions
  } = props;
  const [showLabel, handleLabelAppearance] = useState(!!props.value);
  const onChange = ({ value: newValue }) => {
    handleLabelAppearance(true);
    handleChange && handleChange(selectOptions.name, newValue);
  };

  let selectStyles = { ...defaultStyles, ...styles };
  if (selectForThePushForm) {
    selectStyles = {
      ...selectStyles,
      control: (provided, state) => ({
        ...provided,
        borderRadius: "2px",
        border: "none",
        boxShadow: "none",
        borderBottom: `2px solid ${state.isFocused ? "#063AC9" : "#F2F2F2"}`,
        minHeight: "39px",
        borderBottomColor:
          selectForThePushForm && !state.hasValue && !state.isDisabled
            ? "#E46262"
            : ""
      })
    };
  }

  return (
    <Label
      className={`input-container ${
        selectForThePushForm ? "push-platform-snapchat" : ""
      } select ${containerClass}`}
    >
      <Fade in={!!showLabel} tag="span" className={`input-label ${labelClass}`}>
        {label}
      </Fade>
      <ReactSelect
        defaultValue={value}
        onChange={onChange}
        components={{ DropdownIndicator, IndicatorSeparator }}
        styles={selectStyles}
        options={[
          ...options?.map(option => ({
            ...option,
            label: option[optionLabel],
            value: option[optionValue]
          }))
        ]}
        {...selectOptions}
      />
    </Label>
  );
}

Select.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})])
    .isRequired,
  label: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  containerClass: PropTypes.string,
  labelClass: PropTypes.string,
  inputClass: PropTypes.string,
  optionClass: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  optionLabel: PropTypes.string,
  optionValue: PropTypes.string,
  styles: PropTypes.shape({}),
  selectForThePushForm: PropTypes.bool.isRequired
};

Select.defaultProps = {
  containerClass: "",
  labelClass: "",
  inputClass: "",
  optionClass: "",
  optionLabel: "label",
  optionValue: "value",
  styles: {}
};
